// Server-rendered form feedback needs focus after a navigation.
document.addEventListener('DOMContentLoaded', () => {
  const feedback = [...document.querySelectorAll('[data-msg-form-errors], [data-msg-form-success]')]
    .find(element => element.getClientRects().length);
  if (feedback) feedback.focus();
});
